<template>
  <div style="padding:10px;overflow:auto;height:80vh">
    <el-container>
      <el-header height="6vh">
        <el-button-group>
          <el-button type="primary" icon="el-icon-plus" @click="addUser()">添加</el-button>
        </el-button-group>
      </el-header>
      <el-main>
        <el-table ref="multipleTable" :data="userlist" style="width: 100%" height="68vh">
          <el-table-column label="序号" width="50" type="index" fixed></el-table-column>
          <el-table-column label="账号" prop="account" width="150"></el-table-column>
          <el-table-column label="公司名" prop="company" width="150"></el-table-column>
          <el-table-column label="手机号" prop="phone" width="150"></el-table-column>
          <el-table-column label="可查看产品" prop="producttext"></el-table-column>
          <el-table-column prop="isEnable" label="状态" width="100" align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.isEnable"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :width="30"
                @change="updateState(scope.row.isEnable,scope.row.account)"
                title="启用/停用"
              ></el-switch>
              <el-switch v-if="scope.row.type === 1" :width="30" :disabled="false"></el-switch>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="200">
            <template slot-scope="scope">
              <el-button
                type="primary"
                icon="el-icon-edit"
                size="mini"
                @click="handleEdit(scope.row)"
              ></el-button>
              <el-button
                type="danger"
                icon="el-icon-delete"
                size="mini"
                @click="handleDelete(scope.row)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 添加修改区 开始 -->
        <add-user
          v-if="addShow"
          :Content="userdata"
          :Products="products"
          @hide="hideListAdd"
          @refresh="fetchData"
        ></add-user>
        <edit-user
          v-if="editShow"
          :Content="userdata"
          :Products="products"
          @hide="hideListEdit"
          @refresh="fetchData"
        ></edit-user>
      </el-main>
      <el-footer height="1vh" class="chead">
        <span>共{{totalcount}}条</span>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
import {
  getList as GetUserList,
  deleteUserExtend
} from "../../../api/gm/api-user";
import { getList as GetProductList } from "../../../api/gm/api-product";
import { upState } from "../../../api/main/api-user";
import { deleteAuths } from "../../../api/main/api-auths";
import AddUser from "./add";
import EditUser from "./edit";
export default {
  //..数据
  data() {
    return {
      addShow: false, //添加会员框的显示与隐藏
      editShow: false, //会员修改框显示与隐藏
      products: [],
      userlist: [], //会员信息
      totalcount: 0, //总数
      userdata: {
        id: 0,
        pid: 4,
        account: "",
        password: "",
        name: "",
        phone: "",
        email: "",
        value: "",
        isEnable: true,
        image: null,
        eSign: null,
        company: "",
        projectname: "",
        projectdescribe: "",
        productids: []
      }
    };
  },
  components: {
    "add-user": AddUser,
    "edit-user": EditUser
  },
  created() {
    this.fetchData();
  },
  //..方法
  methods: {
    //..获取列表数据
    fetchData() {
      this.userlist = [];
      GetProductList().then(res => {
        //获取产品
        if (res.code === 0) {
          this.products = res.data;

          GetUserList().then(user => {
            if (user.code === 0) {
              this.fuzhi(user.data);
              this.totalcount = user.data.length;
            } else {
              console.log(user.msg);
            }
          });
        } else {
          console.log(res.msg);
        }
      });
    },
    //赋值
    fuzhi(userdata) {
      // let ud = [];
      userdata.forEach(item => {
        var producttext = this.matchUserProduct(item.productIDs);
        this.userlist.push({
          id: item.id,
          account: item.account,
          name: item.name,
          phone: item.phone,
          email: item.eMail,
          isEnable: item.isEnable,
          company: item.company,
          projectname: item.projectName,
          projectdescribe: item.projectDescribe,
          productids: item.productIDs,
          producttext: producttext
        });
      });
      // this.userlist = ud;
    },
    //..匹配产品名
    matchUserProduct(productids) {
      let productText = "";
      if (this.products.length > 0) {
        //循环可查看的产品
        productids.forEach(prid => {
          this.products.forEach(i => {
            if (i.id == prid) {
              productText += i.name + ",";
            }
          });
        });
      }
      return productText;
    },
    //..隐藏添加框
    hideListAdd() {
      this.addShow = false;
    },
    //..隐藏修改框
    hideListEdit() {
      this.editShow = false;
    },
    //..修改状态
    updateState(enable, account) {
      upState({
        enable: enable,
        accounts: [account]
      }).then(res => {
        if (res.code === 0) {
          this.$message({
            type: enable ? "success" : "info",
            message: res.msg
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //..添加会员
    addUser() {
      this.userdata.id = 0;
      this.userdata.pid = 4;
      this.userdata.account = "";
      this.userdata.password = "";
      this.userdata.name = "";
      this.userdata.phone = "";
      this.userdata.email = "";
      this.userdata.value = "";
      this.userdata.isEnable = true;
      this.userdata.image = null;
      this.userdata.eSign = null;
      this.userdata.company = "";
      this.userdata.projectname = "";
      this.userdata.projectdescribe = "";
      this.userdata.productids = [];
      this.addShow = true;
    },
    //..编辑会员
    handleEdit(row) {
      this.userdata.id = row.id;
      this.userdata.pid = 4;
      this.userdata.account = row.account;
      this.userdata.password = "";
      this.userdata.name = row.name;
      this.userdata.phone = row.phone;
      this.userdata.email = row.email;
      this.userdata.value = "";
      this.userdata.isEnable = row.isEnable;
      this.userdata.image = null;
      this.userdata.eSign = null;
      this.userdata.company = row.company;
      this.userdata.projectname = row.projectname;
      this.userdata.projectdescribe = row.projectdescribe;
      this.userdata.productids = row.productids;
      this.editShow = true;
    },
    //..删除会员
    handleDelete(row) {
      this.$confirm("删除不可恢复,确认?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        lockScroll: false
      })
        .then(() => {
          deleteAuths(row.id).then(res => {
            if (res.code === 0) {
              deleteUserExtend(row.account).then(data => {
                this.fetchData();
                if (res.code === 0) {
                  this.$notify.success({
                    title: "成功",
                    message: "删除成功",
                    duration: 1500
                  });
                } else {
                  this.$notify.error({
                    title: "失败",
                    message: "删除失败",
                    duration: 1500
                  });
                }
              });
            } else {
              this.$notify.error({
                title: "失败",
                message: "删除失败",
                duration: 1500
              });
            }
          });
        })
        .catch(() => {});
    }
  }
};
</script>
<style scoped>
.chead {
  text-align: right;
}
.cheadl {
  text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/pages/gm/userextend/index.vue